export default __webpack_public_path__ + "static/media/about_behind_the_science_hover.d6049085.gif";